import React from "react";
import { identity, startCase } from "lodash";
import { PanelPropertiesCard } from "@sonder/ui/source/styled/components/PanelPropertiesCard";
import { TaskCufSpace, TaskData } from "core/queries/GetTask";
import { formatDate } from "tasks/helpers";

// Exports
export const CLEANING_INFO = {
  heading: "Cleaning",
  options: [
    {
      label: "QA ID",
      path: "qaId",
      transform: startCase,
    },
    {
      label: "Category",
      path: "cleaningRequest.category",
      transform: startCase,
    },
    {
      label: "Cleaning Company",
      path: "cleaningRequest.company.name",
      transform: identity,
    },
    {
      label: "Cleaning Date",
      path: "structuredMetadata.dateToComplete",
      transform: identity,
    },
    // TODO: This is legacy and will be deprecated in favor of earliestStartAt on Task itself
    {
      label: "Earliest Start Time",
      path: "cleaningRequest.startAt",
      transform: formatDate,
      shouldShow: (value: string, data: TaskData) => {
        return !data.earliestStartAt;
      },
    },
    // TODO: This is legacy and will be deprecated in favor of latestEndAt on Task itself
    {
      label: "Latest End Time",
      path: "cleaningRequest.endAt",
      transform: formatDate,
      shouldShow: (value: string, data: TaskData) => {
        return !data.latestEndAt;
      },
    },
    // TODO: This is legacy and will be deprecated in favor of scheduledStartAt on Task itself
    {
      label: "Scheduled Start Time",
      path: "cleaningRequest.cleaning.actualStart",
      transform: formatDate,
      shouldShow: (value: TaskCufSpace, data: TaskData) => {
        return !data.scheduledStartAt;
      },
    },
    // TODO: Annoyingly, some tasks will have to use `actualEnd`, and others will have `dueAt`.
    {
      label: "Scheduled End Time",
      path: "cleaningRequest.cleaning.actualEnd",
      transform: formatDate,
      shouldShow: (value: TaskCufSpace, data: TaskData) => {
        return !data.dueAt || (data.dueAt && value && data.dueAt !== value);
      },
    },
  ],
};

export const LegacyCleaningInfoCard = ({ task }: { task: TaskData }) => (
  <PanelPropertiesCard
    data={task}
    heading={CLEANING_INFO.heading}
    options={CLEANING_INFO.options}
  />
);
